import React from 'react'
import MobileNavigationListSubSection from '../MobileNavigationListSubSection'
import { DepartmentNavigationSubSectionFragment } from '#src/generated/graphql'
import styles from './styles.css'

interface MobileNavigationSubSectionProps {
  section: DepartmentNavigationSubSectionFragment
  onLinkClick?: React.MouseEventHandler
}

const MobileNavigationSubSectionContent: React.SFC<MobileNavigationSubSectionProps> = ({
  section,
  onLinkClick
}) => {
  switch (section.__typename) {
    case 'DepartmentNavigationListSubSection':
      return <MobileNavigationListSubSection section={section} onLinkClick={onLinkClick} />
  }
}

const MobileNavigationSubSection: React.SFC<MobileNavigationSubSectionProps> = ({
  section,
  onLinkClick
}) => {
  return (
    <div className={styles.section}>
      <MobileNavigationSubSectionContent section={section} onLinkClick={onLinkClick} />
    </div>
  )
}

export default MobileNavigationSubSection
